import { sleep } from '../utils'
export { showNativeLoginWithType, openWebViewWithType, setTitle, getUserInfo } from '@tencent/news-jsapi'

let toastInstance: any
/**
 * toast提示
 * 同一时间只有一个toast提示，其他的toast会被直接忽略掉
 * @param text toast的内容
 * @param duration 展示的时间
 */
export const toast = (text: string | number, duration = 1800): Promise<{ left: number; top: number }> => {
  if (toastInstance) {
    // 当前有toast正在展示，直接返回
    return Promise.resolve({ left: -1, top: -1 })
  }

  toastInstance = true
  const ratio = document.documentElement.clientWidth / 375
  const div: HTMLElement = document.createElement('div')
  const { body } = document
  div.className = 'toast'
  div.style.cssText = `position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: -${20 * ratio}px;
  z-index: 9999;
  padding: ${12 * ratio}px ${20 * ratio}px;
  border-radius: ${5 * ratio}px;
  background-color: rgba(255, 255, 255, 0.96);
  color: #111111;
  font-size: ${16 * ratio}px;
  line-height: 1.5;
  white-space: nowrap;
  text-align: center;`
  div && (div.innerHTML = text.toString())
  body.appendChild(div)

  return new Promise(resolve => {
    sleep(duration).then(() => {
      const offset = {
        left: div.offsetLeft,
        top: div.offsetTop
      }
      div && div.parentNode && div.parentNode.removeChild(div)
      toastInstance = false
      resolve(offset)
    })
  })
}

const toastList: Array<string | number> = []
/**
 * 同一时间只有一个toast，其他的toast会先存储起来，然后一个个的弹出
 * @param text toast提示的内容
 */
export const toastWaterFall = async (text: string | number) => {
  if (toastInstance) {
    toastList.push(text)
  } else {
    await toast(text)
    if (toastList.length) {
      while (toastList.length) {
        await sleep(200)
        await toast(`${toastList.shift()}`)
      }
    }
  }
}

// toast提示
export const showTip = (text: string | number) => {
  toastWaterFall(text)
}

const shareDest = (destination: string) => {
  return new Promise(resolve => {
    const callback = (data: any) => {
      resolve(data)
    }

    if (window.TencentNews) {
      window.TencentNews.invoke('share', { destination, onCallback: callback })
    }
  })
}

// 微信好友
export const wechatFriend = () => shareDest('wechatFriend')

// 微信朋友圈
export const moments = () => shareDest('moments')

// QQ 好友
export const qqFriend = () => shareDest('qqFriend')

export const openURL = (url: string) => {
  return new Promise((resolve, reject) => {
    const onCallback = (info: any) => {
      resolve(info)
    }

    if (window.TencentNews) {
      window.TencentNews.invoke('openUrl', {
        url,
        onCallback
      })
    }
  })
}

// weixin
export const openWechat = () => {
  console.log(`openWechat`)
  openURL('weixin://')
}

// mqq
export const openQQ = () => openURL('mqq://')

export const copy = (text: string) => {
  return new Promise(resolve => {
    const callback = (text: string) => {
      resolve(text)
    }
    if (window.TencentNews) {
      window.TencentNews.invoke('copy', { text, onCallback: callback })
    }
  })
}

// TencentNews.invoke('setGestureQuit', {'enabled': false,
//                                       'onCallback': callback});
export const setGestureQuit = (enabled: boolean) => {
  console.log(enabled)
  return new Promise(resolve => {
    const callback = (enabled: boolean) => {
      console.log(`enableed: ${JSON.stringify(enabled)}`)
      resolve(enabled)
    }

    if (window.TencentNews) {
      window.TencentNews.invoke('setGestureQuit', {
        enabled,
        onCallback: callback
      })
    }
  })
}

interface RespProps {
  errCode: string
  errStr: string
  response: string
}

export const isAllPushClose = () => {
  return new Promise(resolve => {
    // android 1 关闭，0 开启
    // ios 1 开启， 0 关闭
    const callback = (push: RespProps) => {
      resolve(push.response)
    }

    if (window.TencentNews) {
      window.TencentNews.invoke('isAllPushClose', { onCallback: callback })
    }
  })
}
export const isNotificationEnabled = () => {
  return new Promise(resolve => {
    const callback = (notification: RespProps) => {
      resolve(notification.response)
    }

    if (window.TencentNews) {
      window.TencentNews.invoke('isNotificationEnabled', { onCallback: callback })
    } else {
      resolve('0')
    }
  })
}

export const gotoPushSwitchSettingPage = () => {
  return new Promise(resolve => {
    const callback = (info: any) => {
      console.log(`gotoPushSwitchSettingPage ${JSON.stringify(info)}`)
      resolve(info)
    }

    if (window.TencentNews) {
      window.TencentNews.invoke('gotoPushSwitchSettingPage', { onCallback: callback })
    }
  })
}

export const reportToBoss = (eventID: string, params: any) => {
  return new Promise(resolve => {
    const callback = (info: any) => {
      console.log(`report bo Boss ${JSON.stringify(info)}`)
      resolve(info)
    }

    if (window.TencentNews) {
      window.TencentNews.invoke('reportToBoss', {
        eventID,
        params,
        onCallback: callback
      })
    }
  })
}
